import { render, staticRenderFns } from "./TemplateProject.vue?vue&type=template&id=6544ae4e&scoped=true"
import script from "./TemplateProject.vue?vue&type=script&lang=js"
export * from "./TemplateProject.vue?vue&type=script&lang=js"
import style0 from "./TemplateProject.vue?vue&type=style&index=0&id=6544ae4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6544ae4e",
  null
  
)

export default component.exports